"use strict";
var Observable_1 = require('../../Observable');
var max_1 = require('../../operator/max');
Observable_1.Observable.prototype.max = max_1.max;
//# sourceMappingURL=max.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/max.js
 ** module id = 230
 ** module chunks = 2
 **/